import { whenDOMReady } from '@abcnews/env-utils';
import { selectMounts } from '@abcnews/mount-utils';
import App from './components/App.svelte';
import { mount } from 'svelte';

whenDOMReady.then(() => {
  const [appMountEl] = selectMounts('ct3d');

  if (appMountEl) {
    appMountEl.classList.add('u-full');

    mount(App, {
      target: appMountEl
    });
  }
});

if (process.env.NODE_ENV === 'development') {
  console.debug(`[ct-3d] public path: ${__webpack_public_path__}`);
}
